import { useCallback, useEffect, useLayoutEffect, useRef } from "react"
import { colours } from "../../../ApartmentFinderConfig/colours"
import { getNestedObject, useAvailableApartments } from "../Utils/hooks"
import { blockInfo } from "../../../ApartmentFinderConfig/blockInfo"
import { useStore } from "../../../state/store"
import { BuildingElevationComponent } from "../../../ApartmentFinderConfig/BuildingElevations"

export function ElevationSvgJsx({ isCard, staticActiveBlock }) {
  const svgref = useRef()

  const returnFloorNumber = id => {
    return Number(id.split("_")[2])
  }

  const storredObjects = {
    ID: useAvailableApartments().map(obj => obj.PlotNumberPlanning)
  }

  const checkAvailableAptOnFloor = (floorNo, buildingID) => {
    return storredObjects.ID.filter(
      obj => Number(obj.split(".")[1]) === floorNo && obj.split(".")[0].charAt(0) === buildingID
    ).length
  }

  const filterHabitable = arr => {
    return arr.filter(e => isHabitable(e.id))
  }

  const isHabitable = v => {
    return (
      blockInfo[activeBlock].habitableFloors.includes(returnFloorNumber(v)) ||
      isNaN(returnFloorNumber(v))
    )
  }

  const selectedFavourite = useStore(state => state.selectedFavourite)
  const favouritesActive = useStore(state => state.favouritesActive)
  const activeBlock = useStore(state => state.activeBlock)
  const bedroomCounts = useStore(state => state.bedroomCounts)
  const bathroomCounts = useStore(state => state.bathroomCounts)
  const activeFloor = useStore(state => state.activeFloor)
  const setActiveFloors = useStore(state => state.setActiveFloors)
  const activeApt = useStore(state => state.activeApt)
  const aspects = useStore(state => state.aspects)

  useEffect(() => {
    return () => setActiveFloors(null)
  }, [])

  const handleFloorClick = useCallback(
    v => {
      setActiveFloors(returnFloorNumber(v.target.id))
    },
    [setActiveFloors]
  )

  useLayoutEffect(() => {
    let floor_buttons = getNestedObject(svgref.current.children, "floor_button")
    let floor_no = getNestedObject(svgref.current.children, "floor_no")
    let apt_no = getNestedObject(svgref.current.children, "apt_no")
    let apt_circle = getNestedObject(svgref.current.children, "apt_circle")
    let floor_circle = getNestedObject(svgref.current.children, "floor_circle")

    //**Floor Circle */
    floor_circle.map(c => c.setAttribute("fill", colours.primaryUILight))

    //**Apartment Circle */
    apt_circle.map(c => c.setAttribute("fill", colours.primaryUILighter))
    apt_circle.map(c => (c.style.display = "none"))
    apt_circle = filterHabitable(apt_circle)
    apt_circle.map(c => (c.style.display = ""))
    //**Apartment Number */
    apt_no.map(c => c.setAttribute("fill", colours.primaryUI))
    apt_no.map(c => (c.style.cursor = "auto"))
    apt_no.map(c => (c.style.fontSize = "2.2em"))
    apt_no.map(c => (c.style.userSelect = "none"))
    apt_no.map(c => (c.style.display = "none"))
    apt_no.map(c => (c.style.paddingLeft = "10px"))
    apt_no.map(c => (c.style.textAnchor = "middle"))
    apt_no.map(c => (c.style.translate = "translate(42px, 0px)"))
    apt_no = filterHabitable(apt_no)
    apt_no.map(c => (c.style.display = ""))
    //**floor number */
    floor_no.map(c => c.setAttribute("fill", colours.offBlack))
    floor_no.map(c => (c.style.cursor = "auto"))
    floor_no.map(c => (c.style.userSelect = "none"))

    //**Apartment Circle */
    floor_buttons.map(c => (c.style.display = "none"))
    floor_buttons = floor_buttons.filter(a => isHabitable(a.id))
    floor_buttons.map(c => (c.style.display = ""))
    floor_buttons.map(c => (c.style.cursor = "pointer"))
    floor_buttons.map(c => (c.style.userSelect = "none"))

    // ** Floor Buttons */
    floor_buttons.map(fb => {
      return fb.setAttribute(
        "fill",
        // "red"
        returnFloorNumber(fb.id) === Number(String(activeFloor))
          ? colours.primaryUI
          : colours.primaryUILighter
      )
    })
    floor_buttons.map(fb =>
      fb.setAttribute(
        "opacity",

        isNaN(returnFloorNumber(fb.id)) ||
          checkAvailableAptOnFloor(returnFloorNumber(fb.id), activeBlock) === 0
          ? 0
          : returnFloorNumber(fb.id) === Number(String(activeFloor))
          ? 0.7
          : 0.4
      )
    )

    //** Interactions */
    apt_no.map(
      c =>
        (c.lastChild.textContent = checkAvailableAptOnFloor(returnFloorNumber(c.id), activeBlock))
    )
    floor_buttons.map(fb =>
      checkAvailableAptOnFloor(returnFloorNumber(fb.id), activeBlock) > 0
        ? (fb.onclick = e => handleFloorClick(e))
        : "null"
    )
  }, [
    favouritesActive,
    selectedFavourite,
    activeFloor,
    bedroomCounts,
    activeBlock,
    activeApt,
    aspects,
    bathroomCounts
  ])

  return <BuildingElevationComponent buildingID={activeBlock} ref={svgref} />
}
